import { useCallback, useEffect, useState } from "react";
import Form from "rc-field-form";
import { Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../../components/Modal";
import ResourceSelectWithImport from "../../../../../../components/Inputs/ResourceSelectWithImpot";
import Button from "../../../../../../components/Button";
import Table from "./Table";
import { useVisible } from "../../../../../../utils/hooks/useVisible";

function ManageAbilityModal({ baseForm, ...config }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [data, setData] = useState(config.defaultValues);
    const [filteredData, setFilteredData] = useState([]);
    const { open, visible, close } = useVisible();

    const onFinish = useCallback((values) => {
        setData((prev) => {
            const ids = prev?.map((item) => item?.id) || [];
            return [
                ...prev,
                ...(values?.[config.name] || [])?.filter((item) => !ids.includes(item?.id)),
            ];
        });
        setFilteredData((prev) => {
            const ids = prev?.map((item) => item?.id) || [];
            return [
                ...prev,
                ...(values?.[config.name] || [])?.filter((item) => !ids.includes(item?.id)),
            ];
        });
        form.resetFields();
    }, [config.name, form]);

    const onClose = useCallback(() => {
        baseForm.setFieldValue(config.name, data);
        form.resetFields();
        close();
    }, [close, baseForm, config.name, data, form]);

    useEffect(() => {
        setData(config?.defaultValues);
        setFilteredData(config?.defaultValues);
    }, [config?.defaultValues]);

    return (
        <>
            <div className="d-flex flex-row align-items-center justify-content-between gap-2 cursor-pointer mb-3" >
                <div
                    className="d-flex align-items-center gap-2 cursor-pointer py-2"
                    onClick={open}
                >
                    <FontAwesomeIcon
                        className="text-info"
                        icon={faPlusCircle}
                        size="sm"
                    />
                    <span>{config.label}</span>
                </div>

                <span className="text-muted text-sm">{"("}{data.length} {t("items").toLowerCase()}{")"}</span>
            </div>

            <Modal
                isOpen={visible}
                centered
                size="lg"
                title={(
                    <div className="d-flex align-items-center justify-content-between gap-2">
                        <span>
                            {t("management") + ": " + config.label}
                        </span>

                        <FontAwesomeIcon
                            className="cursor-pointer"
                            icon={faClose}
                            onClick={onClose}
                        />
                    </div>
                )}
            >
                <Row className="py-4 px-2 w-100" style={{ height: "400px" }}>
                    <Col sm={7}>
                        <Table
                            name={config.name}
                            data={data}
                            setData={setData}
                            filteredData={filteredData}
                            setFilteredData={setFilteredData}
                        />
                    </Col>

                    <Col sm={5} style={{ height: "calc(100% - 140px)", overflow: "auto" }}>
                        <Form form={form} onFinish={onFinish}>
                            <ResourceSelectWithImport {...config} form={form} />
                            <div className="d-flex justify-content-end">
                                <Button color="muted" type="button" onClick={onClose}>
                                    {t("close")}
                                </Button>

                                <Button color="primary">
                                    {t("add")}
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default ManageAbilityModal;
